import Maybe from "graphql/tsutils/Maybe";
import {PaymentTransferType} from "../generated/graphql";
import {getPaymentMethodType, PaymentMethodData} from "./getPaymentMethodType";

// /////////////////////////////////////////////////////////////////////////////////////////////// //
// Spiegel von src/server/booking/paymentMethodIncompleteError.ts (B-82808).                       //
// Der Server wirft bei explizit gewählten, leeren Lastschrift-Methoden einen ApolloError mit      //
// Code PAYMENT_METHOD_INCOMPLETE. Damit der Admin im Buchungs-Wizard gar nicht erst hineinläuft   //
// (Fehler dort = Wizard-Zustand verloren), deaktiviert der Client solche Zeilen vorab.            //
// Logik muss zur Server-Datei synchron bleiben.                                                   //
// /////////////////////////////////////////////////////////////////////////////////////////////// //

export type PaymentMethodUsabilityData = PaymentMethodData & {type?: Maybe<PaymentTransferType>};

/** false nur für Lastschrift-Methoden (per Klassifikator oder gespeichertem Typ) ohne Inhaber oder IBAN. */
export const isPaymentMethodUsableForBooking = (paymentMethod?: PaymentMethodUsabilityData | null): boolean => {
    if (!paymentMethod) {
        return true;
    }

    const isSepaDebit =
        getPaymentMethodType(paymentMethod) === "sepaDebit"
        || paymentMethod.type === PaymentTransferType.SepaDebit;

    return (
        !isSepaDebit
        || ((paymentMethod.sepaAccountholder ?? "").trim() !== "" && (paymentMethod.iban ?? "").trim() !== "")
    );
};
